export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Políticas de privacidad`,
    cloneTitleNoun: `políticas del alojamiento`,
    cloneItemNoun: `las políticas`,
    editorHintLang: `Política de privacidad en {label}`,
    optional: `(opcional)`,
    headingOpt1: `Título 1`,
    headingOpt2: `Título 2`,
    headingOpt3: `Título 3`,
    headingNormal: `Normal`,
    tipBold: `Negrita`,
    tipItalic: `Cursiva`,
    tipUnderline: `Subrayado`,
    tipListOrdered: `Lista ordenada`,
    tipListBullet: `Lista con viñetas`,
    tipLink: `Enlace`,
    tipQuote: `Cita`,
    tipClean: `Limpiar formato`,
    charCount: `{count} carácter | {count} caracteres`,
    saving: `Guardando…`,
    editorPlaceholder: `Escribe aquí la política de privacidad en {label}…`,
    errNoListing: `No se encontró el listing.`,
    errLoad: `No se pudo cargar la política de privacidad.`,
    errEsRequired: `La política en español es obligatoria.`,
    saveSuccess: `Políticas de privacidad guardadas correctamente.`,
    saveError: `Error al guardar las políticas.`,
  },
  rooms: {
    bulkTitle: `Crear habitaciones en lote`,
    bulkSubtitle: `Genera varias habitaciones para un tipo, con código automático y descripción opcional.`,
    available: `Disponibles: {count}`,
    willCreate: `Se crearán: {count}`,
    needTypeFirst: `Primero crea al menos un <b>Tipo de habitación</b> para poder generar habitaciones.`,
    labelType: `Tipo`,
    selectType: `Selecciona un tipo`,
    labelQuantity: `Cantidad`,
    phQuantity: `Ej: 10`,
    labelPrefix: `Prefijo código`,
    phPrefix: `Ej: A- o 10`,
    optional: `Opcional`,
    labelStart: `Inicio`,
    labelPadding: `Padding`,
    labelDescription: `Descripción (opcional)`,
    phDescription: `Se aplicará a las habitaciones creadas`,
    nameEqType: `Nombre = Tipo`,
    recommended: `(recomendado)`,
    example: `Ejemplo:`,
    createBulk: `Crear en lote`,
    typeFallback: `Tipo`,
    previewFormat: `{name} • Código: {code}`,
    noActivePlan: `No tienes un plan activo para crear habitaciones.`,
    limitReached: `Límite alcanzado: tu plan permite {limit} habitaciones para esta propiedad.`,
    selectTypeWarn: `Selecciona un tipo de habitación.`,
    invalidQuantity: `Indica una cantidad válida.`,
    cannotAddMore: `No puedes agregar más. Límite: {limit}.`,
    partialCreated: `Solo se crearon {created} porque tu plan permite {limit} y te quedaban {remaining}.`,
    planLimitSave: `Tu plan permite {limit} habitaciones. Estás intentando guardar {count}.`,
  },
  images: {
    zipDownloadTitle: `Descarga todas las imágenes de la propiedad en un ZIP`,
    zipNoImages: `No hay imágenes para descargar`,
    preparing: `Preparando…`,
    downloadImages: `Descargar imágenes`,
    loading: `Cargando imágenes…`,
    noAccommodations: `No hay alojamientos configurados todavía para esta propiedad.`,
    engineCoverTag: `Portada del motor`,
    imageCount: `{count} imagen | {count} imágenes`,
    hotelPhotosDesc: `Fotos generales (patio, entrada, recepción…) que verá el cliente al abrir el motor`,
    dragToOrder: `Arrastra para ordenar la galería`,
    ordering: `Ordenando…`,
    dragTip: `Arrastrar`,
    hotelSectionName: `Fotos del hotel · zonas comunes`,
    orderUpdated: `Orden de imágenes actualizado.`,
    orderError: `No se pudo actualizar el orden de las imágenes.`,
    downloadError: `No se pudieron descargar las imágenes.`,
  },
};
